import { createAction } from "@reduxjs/toolkit";
import { createApiThunk } from "@shared-kernel/application/create-api-thunk";

export const adminValidateTeacherPayout = createApiThunk<void, { payoutId: string }>(
  "teacherPayouts/adminValidateTeacherPayout",
  async ({ payoutId }, { extra: { adminRepository } }) => {
    await adminRepository!.validateTeacherPayout({ payoutId });
  },
);

export const resetTeacherPayoutValidation = createAction("teacherPayouts/resetTeacherPayoutValidation");
